import styled from 'styled-components'

export const ProgressBarWrapper = styled.ul`
	display: flex;
	padding: 0px;
	margin: 0px;
	margin-top: -25px;
`

interface ActiveProps {
	isActive?: boolean
	isVisible?: boolean
}

export const ProgressBarStep = styled.li<ActiveProps>`
	flex: auto;
	list-style-type: none;
	background: ${(props) =>
		props.isActive ? 'var(--btn-color)' : 'var(--border-color)'};
	height: 4px;
	margin-left: 1px;
	margin-right: 1px;
`
export const PageOf = styled.p`
	margin-left: 5px;
	color: white;
	font-size: 12px;
	letter-spacing: 0.25px;
`

export const BackButton = styled.div<Pick<ActiveProps, 'isVisible'>>`
	margin-left: 5px;
	cursor: pointer;
	// position: absolute;
	z-index: 9999;
	align-self: center;
	visibility: ${(props) => (props.isVisible ? 'visible' : 'hidden')};
`

export const Image = styled.img`
	height: 12px;
`

export const PageWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin: 10px;
`
